export default __webpack_public_path__ + "static/making-sad-248568dc71958a8779dd0e24ceb61123.svg";